import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import * as Sentry from '@sentry/react'

import createRootReducer from './rootReducer'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

const rootReducer = createRootReducer()
const enhancer = applyMiddleware(
  thunk,
)
const compose = (g, f) => x => g(f(x))
const configureStore = params => {
  return createStore(rootReducer, compose(composeWithDevTools(enhancer), sentryReduxEnhancer))
}

export default configureStore
